import { render, staticRenderFns } from "./FornecedorVarejoSidebarImportacao.vue?vue&type=template&id=d35c1806&"
import script from "./FornecedorVarejoSidebarImportacao.vue?vue&type=script&lang=js&"
export * from "./FornecedorVarejoSidebarImportacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
